import { render, staticRenderFns } from "./BackGroundPage.vue?vue&type=template&id=bd153358&scoped=true"
import script from "./BackGroundPage.vue?vue&type=script&lang=js"
export * from "./BackGroundPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/background/BackGroundPage.css?vue&type=style&index=0&id=bd153358&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd153358",
  null
  
)

export default component.exports